import React from 'react';
import Modal from '@atlaskit/modal-dialog';
import { ct } from '../constant-Utils';

const CreatedRoom = ({ closeDialog, isLogged, openLogin }) => {
    const actions = [
      { text: 'Ok', onClick: () => closeDialog('') },
    ];
	
	return (
	    <Modal actions={actions} onClose={ () => closeDialog('') } heading="Room Info">
	     { !isLogged ?
			<div className="model-alert" style={{color:"#000"}}>{ct("rta-trmc.createdRoom.messageOne")} <div className="click-here-model" onClick={ () => openLogin(true) } >{ct("rta-trmc.createdRoom.here")}</div> {ct("rta-trmc.createdRoom.messageTwo")}</div> :
			<div className="model-alert" style={{color:"#000"}}>{ct("rta-trmc.createdRoom.messageThree")} <div className="click-here-model" onClick={ () => closeDialog('claim-room')  }>{ct("rta-trmc.createdRoom.here")}</div> {ct("rta-trmc.createdRoom.messageFour")}</div>
	     }
        </Modal>
	);

}

export default CreatedRoom;
